import axios from 'axios'

export function request_get(url) {
  return axios.get(url)
    .then((res) => {
      return Promise.resolve(res.data)
    }).catch((err) => {
      return Promise.reject(err)
    })
}

export function request_post(url, data) {
  return axios.post(url, data)
    .then((res) => {
      return Promise.resolve(res.data)
    }).catch((err) => {
      return Promise.reject(err)
    })
}



// WEBPACK FOOTER //
// ./src/common/im/request.js